export default __webpack_public_path__ + "static/media/b1.3bcfc2a4.svg";